import * as queries from "./actions/queries";
import * as commands from "./actions/commands";

export let initialState = {
  fetching: false,
  fetched: false,
  data: {},
  error: undefined,
  change: {
    sending: false,
    error: false,
    set: false,
  },
};

const ssnBlock = (state = initialState, action = { type: "" }) => {
  switch (action.type) {
    case queries.SSN_BLOCK_INFO_DATA_FETCH_REQUEST: {
      return Object.assign({}, state, { fetching: true });
    }

    case queries.SSN_BLOCK_INFO_DATA_FETCH_SUCCESS: {
      return Object.assign({}, state, {
        fetching: false,
        fetched: true,
        data: Object.assign(
          { Ssn: action.additionalData.Ssn },
          action.response,
        ),
      });
    }

    case queries.SSN_BLOCK_INFO_DATA_FETCH_ERROR: {
      return Object.assign({}, state, {
        fetching: false,
        fetched: true,
        error: action.error,
      });
    }
    ///////////////////////////////////

    case commands.SSN_BLOCK_INFO_REQUEST: {
      return Object.assign({}, state, {
        change: Object.assign({}, state.change, { sending: true }),
      });
    }

    case commands.SSN_BLOCK_INFO_SUCCESS: {
      return Object.assign({}, state, {
        data: Object.assign(
          {},
          {
            Ssn: action.dataSent.Ssn,
            IsBlocked: true,
            Reason: action.dataSent.Reason,
          },
        ),
        change: Object.assign({}, state.change, { sending: false }),
      });
    }

    case commands.SSN_BLOCK_INFO_ERROR: {
      return Object.assign({}, state, {
        change: Object.assign({}, state.change, { error: action.error }),
      });
    }
    ////////////////////////////////////////////

    case commands.SSN_UNBLOCK_INFO_REQUEST: {
      return Object.assign({}, state, {
        change: Object.assign({}, state.change, { sending: true }),
      });
    }

    case commands.SSN_UNBLOCK_INFO_SUCCESS: {
      return Object.assign({}, state, {
        data: Object.assign(
          {},
          { Ssn: action.dataSent.Ssn, IsBlocked: false, Reason: "" },
        ),
        change: Object.assign({}, state.change, { sending: false }),
      });
    }

    case commands.SSN_UNBLOCK_INFO_ERROR: {
      return Object.assign({}, state, {
        change: Object.assign({}, state.change, { error: action.error }),
      });
    }

    default:
      return state;
  }
};

export default ssnBlock;
